module.exports = __webpack_public_path__ + "static/media/imgHeader_portal.bbe004ab.png";